import React from 'react';
import { useCalendar } from '@/hooks/useCalendar';

/**
 * This component initializes calendar data by calling the useCalendar hook.
 * It doesn't render anything visible but ensures calendar data is loaded.
 */
const CalendarInitializer: React.FC = () => {
  // Call the useCalendar hook to initialize calendar data
  useCalendar();
  
  // This component doesn't render anything
  return null;
};

export default CalendarInitializer; 